import { Media } from "./common.js";
import {
  LayoutData_ImagePosition,
  LayoutData_ResponsivenessBehaviour,
  LayoutData_VerticalAlignment_Alignment,
  LayoutData_ImageScaling_Scaling
} from "./node_layout.enums.js";
function layoutData_ImagePositionFromJSON(object) {
  switch (object) {
    case 0:
    case "CENTER":
      return LayoutData_ImagePosition.CENTER;
    case 1:
    case "CENTER_LEFT":
      return LayoutData_ImagePosition.CENTER_LEFT;
    case 2:
    case "CENTER_RIGHT":
      return LayoutData_ImagePosition.CENTER_RIGHT;
    case 3:
    case "TOP":
      return LayoutData_ImagePosition.TOP;
    case 4:
    case "TOP_LEFT":
      return LayoutData_ImagePosition.TOP_LEFT;
    case 5:
    case "TOP_RIGHT":
      return LayoutData_ImagePosition.TOP_RIGHT;
    case 6:
    case "BOTTOM":
      return LayoutData_ImagePosition.BOTTOM;
    case 7:
    case "BOTTOM_LEFT":
      return LayoutData_ImagePosition.BOTTOM_LEFT;
    case 8:
    case "BOTTOM_RIGHT":
      return LayoutData_ImagePosition.BOTTOM_RIGHT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LayoutData_ImagePosition.UNRECOGNIZED;
  }
}
function layoutData_ImagePositionToJSON(object) {
  switch (object) {
    case LayoutData_ImagePosition.CENTER:
      return "CENTER";
    case LayoutData_ImagePosition.CENTER_LEFT:
      return "CENTER_LEFT";
    case LayoutData_ImagePosition.CENTER_RIGHT:
      return "CENTER_RIGHT";
    case LayoutData_ImagePosition.TOP:
      return "TOP";
    case LayoutData_ImagePosition.TOP_LEFT:
      return "TOP_LEFT";
    case LayoutData_ImagePosition.TOP_RIGHT:
      return "TOP_RIGHT";
    case LayoutData_ImagePosition.BOTTOM:
      return "BOTTOM";
    case LayoutData_ImagePosition.BOTTOM_LEFT:
      return "BOTTOM_LEFT";
    case LayoutData_ImagePosition.BOTTOM_RIGHT:
      return "BOTTOM_RIGHT";
    default:
      return "UNKNOWN";
  }
}
function layoutData_ResponsivenessBehaviourFromJSON(object) {
  switch (object) {
    case 0:
    case "STACK":
      return LayoutData_ResponsivenessBehaviour.STACK;
    case 1:
    case "WRAP":
      return LayoutData_ResponsivenessBehaviour.WRAP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LayoutData_ResponsivenessBehaviour.UNRECOGNIZED;
  }
}
function layoutData_ResponsivenessBehaviourToJSON(object) {
  switch (object) {
    case LayoutData_ResponsivenessBehaviour.STACK:
      return "STACK";
    case LayoutData_ResponsivenessBehaviour.WRAP:
      return "WRAP";
    default:
      return "UNKNOWN";
  }
}
function layoutData_VerticalAlignment_AlignmentFromJSON(object) {
  switch (object) {
    case 0:
    case "TOP":
      return LayoutData_VerticalAlignment_Alignment.TOP;
    case 1:
    case "MIDDLE":
      return LayoutData_VerticalAlignment_Alignment.MIDDLE;
    case 2:
    case "BOTTOM":
      return LayoutData_VerticalAlignment_Alignment.BOTTOM;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LayoutData_VerticalAlignment_Alignment.UNRECOGNIZED;
  }
}
function layoutData_VerticalAlignment_AlignmentToJSON(object) {
  switch (object) {
    case LayoutData_VerticalAlignment_Alignment.TOP:
      return "TOP";
    case LayoutData_VerticalAlignment_Alignment.MIDDLE:
      return "MIDDLE";
    case LayoutData_VerticalAlignment_Alignment.BOTTOM:
      return "BOTTOM";
    default:
      return "UNKNOWN";
  }
}
function layoutData_ImageScaling_ScalingFromJSON(object) {
  switch (object) {
    case 0:
    case "AUTO":
      return LayoutData_ImageScaling_Scaling.AUTO;
    case 1:
    case "CONTAIN":
      return LayoutData_ImageScaling_Scaling.CONTAIN;
    case 2:
    case "COVER":
      return LayoutData_ImageScaling_Scaling.COVER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LayoutData_ImageScaling_Scaling.UNRECOGNIZED;
  }
}
function layoutData_ImageScaling_ScalingToJSON(object) {
  switch (object) {
    case LayoutData_ImageScaling_Scaling.AUTO:
      return "AUTO";
    case LayoutData_ImageScaling_Scaling.CONTAIN:
      return "CONTAIN";
    case LayoutData_ImageScaling_Scaling.COVER:
      return "COVER";
    default:
      return "UNKNOWN";
  }
}
const baseLayoutData = {
  cellPadding: 0,
  cellVerticalAlignment: LayoutData_VerticalAlignment_Alignment.TOP,
  responsivenessBehaviour: LayoutData_ResponsivenessBehaviour.STACK
};
const LayoutData = {
  fromJSON(object) {
    const message = { ...baseLayoutData };
    message.backgroundColor = object.backgroundColor !== void 0 && object.backgroundColor !== null ? String(object.backgroundColor) : void 0;
    message.backgroundImage = object.backgroundImage !== void 0 && object.backgroundImage !== null ? LayoutData_BackgroundImage.fromJSON(object.backgroundImage) : void 0;
    message.borderColor = object.borderColor !== void 0 && object.borderColor !== null ? String(object.borderColor) : void 0;
    message.borderWidth = object.borderWidth !== void 0 && object.borderWidth !== null ? Number(object.borderWidth) : void 0;
    message.borderRadius = object.borderRadius !== void 0 && object.borderRadius !== null ? Number(object.borderRadius) : void 0;
    message.backdropColor = object.backdropColor !== void 0 && object.backdropColor !== null ? String(object.backdropColor) : void 0;
    message.backdropImage = object.backdropImage !== void 0 && object.backdropImage !== null ? LayoutData_BackgroundImage.fromJSON(object.backdropImage) : void 0;
    message.backdropPaddingTop = object.backdropPaddingTop !== void 0 && object.backdropPaddingTop !== null ? Number(object.backdropPaddingTop) : void 0;
    message.backdropPaddingBottom = object.backdropPaddingBottom !== void 0 && object.backdropPaddingBottom !== null ? Number(object.backdropPaddingBottom) : void 0;
    message.gap = object.gap !== void 0 && object.gap !== null ? Number(object.gap) : void 0;
    message.cellPadding = (object.cellPadding ?? []).map((e) => Number(e));
    message.cellVerticalAlignment = object.cellVerticalAlignment !== void 0 && object.cellVerticalAlignment !== null ? layoutData_VerticalAlignment_AlignmentFromJSON(object.cellVerticalAlignment) : LayoutData_VerticalAlignment_Alignment.TOP;
    message.responsivenessBehaviour = object.responsivenessBehaviour !== void 0 && object.responsivenessBehaviour !== null ? layoutData_ResponsivenessBehaviourFromJSON(object.responsivenessBehaviour) : LayoutData_ResponsivenessBehaviour.STACK;
    message.responsivenessBreakpoint = object.responsivenessBreakpoint !== void 0 && object.responsivenessBreakpoint !== null ? Number(object.responsivenessBreakpoint) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.backgroundColor !== void 0 && (obj.backgroundColor = message.backgroundColor);
    message.backgroundImage !== void 0 && (obj.backgroundImage = message.backgroundImage ? LayoutData_BackgroundImage.toJSON(message.backgroundImage) : void 0);
    message.borderColor !== void 0 && (obj.borderColor = message.borderColor);
    message.borderWidth !== void 0 && (obj.borderWidth = message.borderWidth);
    message.borderRadius !== void 0 && (obj.borderRadius = message.borderRadius);
    message.backdropColor !== void 0 && (obj.backdropColor = message.backdropColor);
    message.backdropImage !== void 0 && (obj.backdropImage = message.backdropImage ? LayoutData_BackgroundImage.toJSON(message.backdropImage) : void 0);
    message.backdropPaddingTop !== void 0 && (obj.backdropPaddingTop = message.backdropPaddingTop);
    message.backdropPaddingBottom !== void 0 && (obj.backdropPaddingBottom = message.backdropPaddingBottom);
    message.gap !== void 0 && (obj.gap = message.gap);
    if (message.cellPadding) {
      obj.cellPadding = message.cellPadding.map((e) => Math.round(e));
    } else {
      obj.cellPadding = [];
    }
    message.cellVerticalAlignment !== void 0 && (obj.cellVerticalAlignment = layoutData_VerticalAlignment_AlignmentToJSON(
      message.cellVerticalAlignment
    ));
    message.responsivenessBehaviour !== void 0 && (obj.responsivenessBehaviour = layoutData_ResponsivenessBehaviourToJSON(
      message.responsivenessBehaviour
    ));
    message.responsivenessBreakpoint !== void 0 && (obj.responsivenessBreakpoint = message.responsivenessBreakpoint);
    return obj;
  }
};
const baseLayoutData_VerticalAlignment = {};
const LayoutData_VerticalAlignment = {
  fromJSON(_) {
    const message = { ...baseLayoutData_VerticalAlignment };
    return message;
  },
  toJSON(_) {
    const obj = {};
    return obj;
  }
};
const baseLayoutData_ImageScaling = {};
const LayoutData_ImageScaling = {
  fromJSON(_) {
    const message = { ...baseLayoutData_ImageScaling };
    return message;
  },
  toJSON(_) {
    const obj = {};
    return obj;
  }
};
const baseLayoutData_BackgroundImage = {
  scaling: LayoutData_ImageScaling_Scaling.AUTO,
  position: LayoutData_ImagePosition.CENTER
};
const LayoutData_BackgroundImage = {
  fromJSON(object) {
    const message = { ...baseLayoutData_BackgroundImage };
    message.media = object.media !== void 0 && object.media !== null ? Media.fromJSON(object.media) : void 0;
    message.opacity = object.opacity !== void 0 && object.opacity !== null ? Number(object.opacity) : void 0;
    message.scaling = object.scaling !== void 0 && object.scaling !== null ? layoutData_ImageScaling_ScalingFromJSON(object.scaling) : LayoutData_ImageScaling_Scaling.AUTO;
    message.position = object.position !== void 0 && object.position !== null ? layoutData_ImagePositionFromJSON(object.position) : LayoutData_ImagePosition.CENTER;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.media !== void 0 && (obj.media = message.media ? Media.toJSON(message.media) : void 0);
    message.opacity !== void 0 && (obj.opacity = message.opacity);
    message.scaling !== void 0 && (obj.scaling = layoutData_ImageScaling_ScalingToJSON(message.scaling));
    message.position !== void 0 && (obj.position = layoutData_ImagePositionToJSON(message.position));
    return obj;
  }
};
export {
  LayoutData,
  LayoutData_BackgroundImage,
  LayoutData_ImageScaling,
  LayoutData_VerticalAlignment,
  layoutData_ImagePositionFromJSON,
  layoutData_ImagePositionToJSON,
  layoutData_ImageScaling_ScalingFromJSON,
  layoutData_ImageScaling_ScalingToJSON,
  layoutData_ResponsivenessBehaviourFromJSON,
  layoutData_ResponsivenessBehaviourToJSON,
  layoutData_VerticalAlignment_AlignmentFromJSON,
  layoutData_VerticalAlignment_AlignmentToJSON
};
//# sourceMappingURL=node_layout.js.map
